export const EmailRegex = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-_]+\.[A-Za-z]{2,}$/;
export const UsernameRegex = /^[a-zA-Z0-9_]{4,20}$/;
export const ROLES = {
  Super_admin: "1000",
  Instructor: "1001",
  Scenario_developer: "1002",
  Student: "1003",
  Guest: "1004",
  Support: "1005",
  Custom_role: "1006",
  User: "1007",
  Manager: "1009",
};
